import { Switch } from '@headlessui/react'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface CheckBoxSwitcherProps {
  selected: boolean
  onChange: (value: boolean) => void
  label?: string | React.ReactNode
  labelClassName?: string
  disabled?: boolean
}

const CheckBoxSwitcher = ({
  selected,
  onChange,
  label,
  labelClassName,
  disabled,
}: CheckBoxSwitcherProps) => {
  return (
    <div className="relative flex flex-col gap-2 md:flex-row">
      <Switch
        checked={selected}
        onChange={onChange}
        className={twMerge(
          'main-transition-colors relative inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-background-secondary/75',
          selected && !disabled ? 'bg-brand-primary' : 'bg-background-tertiary',
        )}
      >
        <span
          aria-hidden="true"
          className={twMerge(
            selected ? 'translate-x-5' : 'translate-x-0',
            'main-transition-colors pointer-events-none inline-block size-4 rounded-full bg-background-secondary shadow-lg ring-0 transition-transform duration-200 ease-linear',
          )}
        />
      </Switch>
      {label && <div className={labelClassName}>{label}</div>}
    </div>
  )
}

export default CheckBoxSwitcher
